/**
 * Calls the `onHidden` callback the first time that the broswer tab loses focus.
 */
const onDocumentHiddenOnce = (onHidden: () => void) => {
  const callback = () => {
    if (document.hidden) {
      document.removeEventListener('visibilitychange', callback);
      onHidden();
    }
  };
  document.addEventListener('visibilitychange', callback);
};

export default onDocumentHiddenOnce;
